import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { emit, triggerError } from "../utils/eventManager";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
import * as api from "./apis/mfa";
import { setTokens } from "./setTokens";
export { sendEmail, doMfa, getMfaToken, isUserMfa };
async function sendEmail(token) {
  return await api.sendEmail(token);
}
async function doMfa(mfaToken, oobCode, mfaCode, deviceId) {
  try {
    sendNewRelicEvent({
      EventName: 'mfa_start'
    });
    var tokens = await api.doMfa(mfaToken, oobCode, mfaCode, deviceId);
    var idToken = tokens.idToken,
      accessToken = tokens.accessToken;
    emit('login.success', tokens);
    sendNewRelicEvent({
      EventName: 'mfa_success'
    });
    await setTokens({
      idToken: idToken,
      accessToken: accessToken,
      callInitSession: true,
      authActionType: 'login'
    });
    return tokens;
  } catch (e) {
    sendNewRelicEvent({
      EventName: 'mfa_failed',
      error: e
    });
    triggerError('mfa', e);
    throw e;
  }
}
async function getMfaToken(clientId) {
  return await api.getMfaToken(clientId);
}
function isUserMfa() {
  try {
    var accessToken = document.cookie.split('; ').find(function (c) {
      return c.includes('access_token=');
    });
    if (!accessToken) {
      return false;
    }
    var _accessToken$slice$sp = accessToken.slice(accessToken.indexOf('=') + 1).split('.'),
      _accessToken$slice$sp2 = _slicedToArray(_accessToken$slice$sp, 2),
      _ = _accessToken$slice$sp2[0],
      token = _accessToken$slice$sp2[1];
    var decodedToken = JSON.parse(atob(token));
    return !!decodedToken.chgmfa;
  } catch (e) {
    return false;
  }
}